import React, { useEffect, useMemo, useRef, useState } from 'react';
import Form from 'react-bootstrap/Form';
import ConfirmationAlertTwo from 'components/ConfirmationAlert/ConfirmationAlertTwo';
import NotificationAlert from "react-notification-alert";
import Purchaser from '../../lib/Core/Backend/Controllers/Purchaser';
import Notify from 'lib/Utils/Alert';
import { Button, Label, Input, FormGroup, Container, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import RepresentativeUser from '../../lib/Core/Backend/Controllers/RepresentativeUsers';
import Spinner from 'react-bootstrap/Spinner';
import { log10 } from 'chart.js/helpers';

const mapKeys = {
  active: 'active',
  apiUser: 'apiUser',
  permissions: 'permissions'
}

const Notifications = ({ purchaserId, token }) => {

  const userForm = useRef();
  const alert = useRef();
  const purchaserCtl = useMemo(() => new Purchaser(token), [token]);
  const representativeUsersClt = useMemo(() => new RepresentativeUser(token), [token]);
  const [modal, setModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [reload, setReload] = useState(false);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [loader, setLoader] = useState(true)
  const [contactsList, setContactsList] = useState([]);
  const [activeOp, setActiveOp] = useState('Add new');
  const [showAlertMessage, setShowAlertMessage] = useState(false)
  const [initialData, setInitialData] = useState({})
  const [selectedContact, setSelectedContact] = useState(null)
  const [selectMail, setSelectMail] = useState("");
  const [error, setError] = useState("");
  const [selectedRadio, setSelectedRadio] = useState({});
  const [id, setId] = useState("");
  const toggleConfirm = () => setConfirmModal(!confirmModal);
  const triggerRelaod = () => setReload(!reload);
  const toggle = () => setModal(!modal);
  const stayModal = () => setShowAlertMessage(false)
  const [searchQuery, setSearchQuery] = useState("");
  const [currentData, setCurrentData] = useState([]);
  const [applyLoader,setApplyLoader] = useState(false);
  const [addEmailLoader,setAddEmailLoader] = useState(false);
  const leaveAllModal = () => {
    setShowAlertMessage(false)
    setModal(false)
  }

  const prepareToAdd = () => {
    setActiveOp('Add new');
    toggle();
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };
  const [selected, setSelected] = useState("");
  const [selected1, setSelected1] = useState("");
  const [selected2, setSelected2] = useState("");
  const [selected3, setSelected3] = useState("");


  const fetchPurchaserData = ()=> {
    
    purchaserCtl.purchaserCheck(purchaserId, (data) => {
      if (data && !data.error) {
        if(data?.users[0]?.enabled == false){
          sessionStorage.removeItem("accessToken")
            window.location.href="purchaser-auth/login"
    }
        
      }else{
       if((data?.errorMessage=="Purchaser not found"&& data?.errorCode=="BAD_REQUEST") || data?.errorMessage=="There is no records on the Purchaser brand limits table"){

          Notify(alert, 'danger', data?.errorMessage ?? data?.error);
              sessionStorage.removeItem("accessToken")
              window.location.href="purchaser-auth/login"
          }
          if((data?.errorMessage.includes("Username was not found") && data?.errorCode=="BAD_REQUEST") || data?.errorMessage=="There is no records on the Purchaser brand limits table"){
    
            Notify(alert, 'danger', data?.errorMessage ?? data?.error);
                sessionStorage.removeItem("accessToken")
                window.location.href="purchaser-auth/login"
            }
      }
})
}


useEffect(()=>{    
fetchPurchaserData();

},[purchaserId])

  useEffect(() => {
    const notificationsObject = {};
    contactsList.forEach(item => {
      const { email, purchaserId, cardDelivery, orderConfirmation, proformaInvoice, orderInvoice } = item;
      setId(purchaserId);

      // Define custom names for each notification type
      const names = {
        cardDelivery: 'cardDelivery',
        orderConfirmation: 'orderConfirmation',
        proformaInvoice: 'proformaInvoice',
        orderInvoice: 'orderInvoice'
      };

      // Initialize arrays for each notification type if they don't exist
      if (!notificationsObject[names.cardDelivery]) {
        notificationsObject[names.cardDelivery] = [];
      }
      if (!notificationsObject[names.orderConfirmation]) {
        notificationsObject[names.orderConfirmation] = [];
      }
      if (!notificationsObject[names.proformaInvoice]) {
        notificationsObject[names.proformaInvoice] = [];
      }
      if (!notificationsObject[names.orderInvoice]) {
        notificationsObject[names.orderInvoice] = [];
      }

      // Push email and value object to the respective notification type array
      if (cardDelivery) {
        notificationsObject[names.cardDelivery].push({ email, value: cardDelivery });
      }
      if (orderConfirmation) {
        notificationsObject[names.orderConfirmation].push({ email, value: orderConfirmation });
      }
      if (proformaInvoice) {
        notificationsObject[names.proformaInvoice].push({ email, value: proformaInvoice });
      }
      if (orderInvoice) {
        notificationsObject[names.orderInvoice].push({ email, value: orderInvoice });
      }
    });
    setSelectedRadio(notificationsObject);
  }, [contactsList]);


  useEffect(() => {
    let data = contactsList?.filter((e) => e?.cardDelivery);
    setSelected(data[0]?.email);
    let data1 = contactsList?.filter((e) => e?.orderConfirmation);
    setSelected1(data1[0]?.email);
    let data2 = contactsList?.filter((e) => e?.proformaInvoice);
    setSelected2(data2[0]?.email);
    let data3 = contactsList?.filter((e) => e?.orderInvoice);
    setSelected3(data3[0]?.email);
  }, [contactsList]);
  /* 
on submit custome Email API call function
  */

  const handleClick = (row, email, index) => {
    if (selected == email) {
      setSelected("")

    } else {
      setSelected(email);

    }
  };
  const handleClick1 = (row, email, index) => {
    if (selected1 == email) {
      setSelected1("")

    } else {
      setSelected1(email);
    }
  };
  const handleClick2 = (row, email, index) => {
    if (selected2 == email) {
      setSelected2("")

    } else {
      setSelected2(email);
    }
  };
  const handleClick3 = (row, email, index) => {
    if (selected3 == email) {
      setSelected3("")

    } else {
      setSelected3(email);
    }
  };
  const contactListAPIcall = () => {
    purchaserCtl.purchaserNotificationList(purchaserId, (data) => {
      setLoader(false)

      if (data && !data.error) {
        // const arr = data?.filter(cont => cont?.cardDelivery == true)
        // setSelectedContact(arr[0])
        setContactsList(data);
        setCurrentData(data)
      } else {

        Notify(alert, 'danger', data.errorMessage ?? data.error);
      }
    })
  }

  const AddemailLoaderFile = () =>{
    setTimeout(() => {
     setAddEmailLoader(false) 
    }, 1500);
  }

  const onSubmitButton = (e) => {
    setAddEmailLoader(true)
    let mail = /\S+@\S+\.\S+/.test(selectMail);
    if (!mail) {
      setError("Email is invalid");
      AddemailLoaderFile()
    } else {
      setError(null);

      fetch(
        `${process.env.REACT_APP_BACKEND_URL}private/backoffice/purchaser/enable/customEmail/${id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify({
            value: true,
            email: selectMail
          }),
        }
      )
        .then((responseData) => {
          // toggle();
          // triggerRelaod();
          // Notify(alert, "success", "Custom mail has been added successfully");
          return responseData.json()
        }).then((data)=>{
          if(data?.errorCode === "BAD_REQUEST"){
            Notify(alert,"danger",data?.errorMessage)
            AddemailLoaderFile()
          }
        })
        .catch((error) => {
          Notify(alert, "danger", "Something went wrong !!");
          AddemailLoaderFile()
        });
    }
  };

  const onApplyByMailFunc = (e, row) => {
    // setSelectedContact(row);
    if (e.target.checked == true) {

      fetch(
        `${process.env.REACT_APP_BACKEND_URL}private/backoffice/purchaser/enableAllEmail/${row?.purchaserId}/${row?.email}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        }
      )
        .then((responseData) => {
          contactListAPIcall();
          Notify(alert, "success", "Applied successfully!!");
        })
        .catch((error) => {
          Notify(alert, "danger", "Something went wrong !!");
          console.error(`Error: ${error}`);
        });

    } else {

      fetch(
        `${process.env.REACT_APP_BACKEND_URL}private/backoffice/purchaser/disableAllEmail/${row?.purchaserId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        }
      )
        .then((responseData) => {

          contactListAPIcall();
          Notify(alert, "success", "Applied successfully!!");
        })
        .catch((error) => {
          Notify(alert, "danger", "Something went wrong !!");
          console.error(`Error: ${error}`);
        });
    }
  };


  const handleModalClose = () => {
    if (activeOp === 'Add New') {
      let hasChanges = false
      userForm.current.forEach(el => {
        if (!!el.value && el.value !== '-1') {
          hasChanges = true
        }
      })

      if (hasChanges) {
        setShowAlertMessage(true)
      } else {
        setModal(false)
      }

    } else {
      const formHasChanges = modelChange(initialData, userForm.current)
      if (formHasChanges) {
        setShowAlertMessage(true)
      } else {
        setModal(!modal)
      }
    }
  }

  const modelChange = (initial, endModel) => {
    let changed = false
    Object.entries(initial).forEach(([key, value]) => {
      if (endModel[mapKeys[key]] && value !== endModel[mapKeys[key]].checked) {
        changed = true
        return
      }
    })
    return changed
  }

  useEffect(() => {
    if (purchaserId) {
      contactListAPIcall()
    }
  }, [reload, purchaserId, purchaserCtl]);


  const handleRadioChange = (e, row) => {
    const { name, checked } = e.target;

    setSelectedRadio(prevState => {
      let currentArray = prevState[name] || [];
      let index = currentArray.findIndex(item => item.email === row?.email);

      if (checked && index === -1) {
        currentArray.push({ email: row?.email, value: true });
      } else if (!checked && index !== -1) {
        currentArray.splice(index, 1);
      }

      return {
        ...prevState,
        [name]: currentArray
      };
    });
  };

  const applyNotificationMail = () => {
   if((selectedRadio.cardDelivery.length === 0) && (selectedRadio.orderConfirmation.length === 0) && (selectedRadio.proformaInvoice.length === 0) && (selectedRadio.orderInvoice.length === 0)){
       Notify(alert,"warning","Please check any of the options before apply")
       return;
    }
    setApplyLoader(true)
    let body = {
      ...selectedRadio,
      purchaserId : purchaserId
      
    }
    purchaserCtl.allnotification(body, (data) => {
      if (data && !data.error) {
        setTimeout(() => {
          setApplyLoader(false);
        }, 1500);
        //  contactListAPIcall()
        Notify(alert, "success", "Notification Send successfully")
        contactListAPIcall()
      } else {
        Notify(alert, "danger", data.error)
        setTimeout(() => {
          setApplyLoader(false);
        }, 1500);
      }
    })
  }

  //// function for global search ///////
  const handleSearchInputChange = (event) => {
    setSearchQuery(event.target.value);
    if (!event.target.value) {
      setCurrentData(contactsList)
    }
    else {
      const searchQuery = event.target.value.trim().toLowerCase();
      if (event.target.value) {
        const searchResults = contactsList?.filter((item) => {
          const fullName = `${item.firstName} ${item.lastName}`.toLowerCase();
          const isMatch = Object.values(item).some((value) =>
            value && value.toString().toLowerCase().includes(searchQuery)
        );
        const isMatchName = fullName.includes(searchQuery);
        return isMatch || isMatchName;
        });
        setCurrentData(searchResults)
        return searchResults.length > 0 ? searchResults : "No match found";
      }
    }
  };

  return (
    <div className='dashboardPage notification'>
      <ConfirmationAlertTwo
      //   stayModal={stayModal} openModal={showAlertMessage} leaveModal={leaveAllModal} 
      />
      <ConfirmationAlertTwo ref={alert} />
      <Container className="mt-4" fluid>
      <NotificationAlert ref={alert} />
        <>
          <h5 className="mb-3">Notifications</h5>
          <div className="sortTools">
            <div className="row g-1 g-sm-3">
              <div className="col-8 col-lg-10 col-xl-3">
                <div className="searchSort position-relative">
                  <input type="text" placeholder='Search' className='form-control pe-5' value={searchQuery} onChange={handleSearchInputChange} />
                  <button className='d-flex align-items-center btn  position-absolute h-100 px-3' style={{right:"0",top:"50%",transform:"translate(-1%,-50%)",background: "#2665F2"}}><i className='bx bx-search' style={{color:"white"}}></i></button>
                </div>
              </div>
              <div className="col-auto col-lg-auto ms-auto">
                <button className='btn btn-primaryTwo py-2' onClick={prepareToAdd}><i className='bx bxs-user me-1' ></i>  <span className='d-none d-xl-inline'>Add Email</span></button>
              </div>
            </div>
          </div>
          <div className="card table-widget my-4">
            <div className="card-body">
              <div className="table-responsive p-2" style={{ maxHeight: '280px', overflowY: 'hidden'}}>
                <div style={{ overflowY: 'auto', maxHeight: '280px' }}>
                <table className="table table-borderless j_table_borderless  table-hover" style={{ tableLayout: 'fixed', minWidth: '500px'}}>
                  <thead style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>
                    <tr>
                      <th>Name</th>
                      <th>Email</th>
                      <th className='basic_row_change'>Card Delivery</th>
                      <th className='basic_row_change'>Order Confirmation</th>
                      <th className='basic_row_change'>Proforma Invoice</th>
                      <th className='basic_row_change'>Order Invoice</th>

                    </tr>
                  </thead>
                  <tbody>

                    {currentData?.length > 0 ? currentData?.map((row, index) => {
                      const isItemSelected = selectedRadio?.cardDelivery?.some(item => item.email === row.email);
                      const isItemSelected1 = selectedRadio?.orderConfirmation?.some(item => item.email === row.email);
                      const isItemSelected2 = selectedRadio?.proformaInvoice?.some(item => item.email === row.email);
                      const isItemSelected3 = selectedRadio?.orderInvoice?.some(item => item.email === row.email);
                      return (
                        <tr key={index}>
                          <td>{row?.firstName ? row?.firstName : "--"} {row?.lastName ? row?.lastName : "--"}</td>
                          <td>{row?.email}</td>
                          <td className='basic_row_change'>
                            <span onClick={() => handleClick(row, row.email, index)}>
                              <input
                                name={"cardDelivery"}
                                type="checkbox"
                                checked={isItemSelected}
                                onChange={(e) => handleRadioChange(e, row)}
                                style={{ cursor: "pointer" }}
                              />
                            </span>
                          </td>
                          <td className='basic_row_change'>
                            <span onClick={() => handleClick1(row, row.email, index)}>
                              <input
                                name={"orderConfirmation"}
                                type="checkbox"
                                checked={isItemSelected1}
                                onChange={(e) => handleRadioChange(e, row)}
                                style={{ cursor: "pointer" }}
                              />
                            </span>
                          </td>
                          <td className='basic_row_change'>
                            <span onClick={() => handleClick2(row, row.email, index)}>
                              <input
                                name={"proformaInvoice"}
                                type="checkbox"
                                checked={isItemSelected2}
                                onChange={(e) => handleRadioChange(e, row)}
                                style={{ cursor: "pointer" }}
                              />
                            </span>
                          </td>
                          <td className='basic_row_change'>
                            <span onClick={() => handleClick3(row, row.email, index)}>
                              <input
                                name={"orderInvoice"}
                                type="checkbox"
                                checked={isItemSelected3}
                                onChange={(e) => handleRadioChange(e, row)}
                                style={{ cursor: "pointer" }}
                              />
                            </span>
                          </td>
                        </tr>
                      );
                    }) :
                      loader ?
                        <tr>
                          <td colSpan={6}>
                            <div className="spinner-border text-muted text-center"></div>
                          </td>
                        </tr>
                        :
                        <tr>
                          <td colSpan={6}>No data found</td>
                        </tr>
                    }
                  </tbody>
                </table>
                </div>
              </div>
            </div>

            <Modal isOpen={modal} toggle={toggle} backdrop="static" centered={true} size="lg" >
              <ModalHeader className="custom_header_colourTwo modal-header">
                <h2 className=' mb-0' style={{color:"white"}}>Enter email</h2>
              </ModalHeader>

              <ModalBody>
                <Form encType="multipart/form-data">
                  <Input type="hidden" name="cardTypeId" />
                  <FormGroup>
                    <Label for="email">Email</Label>
                    <Input
                      type="email"
                      onChange={(e) => setSelectMail(e.target.value)}
                      name="email"
                      id="email"
                    />
                  </FormGroup>
                </Form>
                

              </ModalBody>
              <ModalFooter>
                <Button type="button" color="secondary" onClick={handleModalClose}>Cancel</Button>
                <Button type="button" className='btn btn-primaryTwo' onClick={onSubmitButton} disabled={addEmailLoader}>{!addEmailLoader &&"Save"}{
                  addEmailLoader && 
                  <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  style={{
                  margin: "0px 8px"
                  }}
                />
                  }</Button>
              </ModalFooter>
            </Modal>
          </div>
          <div className=' d-flex align-items-center justify-content-end'>
            <button className='btn btn-primaryTwo py-2' onClick={() => applyNotificationMail()} disabled={applyLoader} > <span className=''>{!applyLoader && "Apply"}{
              applyLoader && 
              <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
              style={{
              margin: "0px 8px"
              }}
            />
              }</span></button>
          </div>
          {/* </div> */}
        </>
      </Container>
    </div>
  )
}

export default Notifications